const { hotjarInit } = require('./hotjar-init')
const { hotjarTagRecording } = require('./hotjar-tag-recording')
const { hotjarTriggerEvent } = require('./hotjar-trigger-event')

module.exports = {
  hotjarInit,
  hotjarTagRecording,
  hotjarTriggerEvent
}
